import checked from './checked.vue'
export default checked